package games.polyclub.website.frontend.store.layout.userarea

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.message.Message
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.sitemap.Icon
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import react.PropsWithChildren

external interface UserAreaLayoutProps: PropsWithChildren {
    var pageTitle: Message?
    var pageTitleIcon: Icon?
}

val UserAreaLayout = SFC<UserAreaLayoutProps> { props ->
    val authCtx = useAuth()
    val auth = authCtx.auth!!
    val profile = auth.profile

    val pageTitle = -"Área ${"da" / profile} Cliente"
    addBreadcrumb(LoggedSitemap.HOME.rootPath, pageTitle)

    PageHeader {
        title = props.pageTitle ?: pageTitle
        titleIcon = props.pageTitleIcon ?: LoggedSitemap.HOME.icon
    }
    PageBody {
        div("container-fluid") {
            div("row") {
                div("col-md-2") {
                    UserAreaMenuComponent()
                }
                div("col-md-10") {
                    +props.children
                }
            }
        }
    }
}
